<div class="widget">
  <div class="amSuite-widget-header">
    {{ 'widgets.user-projects.title' | translate }}
    @if (modify) {
    <a href="javascript:void(0)" (click)="pjpop()" class="modify-btn"
      pTooltip="{{ 'widgets.user-projects.edit' | translate }}">
      <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
    </a>
    }
    <small class="date-font"><i>({{initialDate | dateMoment:shortDate}} - {{finalDate |
        dateMoment:shortDate}})</i></small>
  </div>

  <div class="amSuite-widget-block height-auto">

    @if (projects && projects.length > 0) {
    <div>
      @for (prj of projects; track $index) {
      <div>
        <div class="row widgetBodyBoxBlue">
          <div class="col-sm-1 col-md-1 col-lg-1" style="display: flex; justify-content: center;">
            <p-tag [severity]="stateConfig[prj.workingState].severity" 
                  [icon]="stateConfig[prj.workingState].icon + ' font-semibold'" 
                  [rounded]="true" 
                  styleClass="p-tag-outlined">
            </p-tag>
          </div>
          <div class="col-sm-10 col-md-10 col-lg-10">
            <div class="title-row">
              <a class="title-link" href="javascript:void(0)" (click)="modify ? '' :onSelectProject(prj)">
                <h6 class="title-text">{{ prj.title }}</h6>
              </a>
              <div class="icons">
                @if (prj.isShared) {
                  <i class="pi pi-share-alt" aria-hidden="true"
                    [pTooltip]="'widgets.user-projects.sharedWithMe' | translate"></i>
                }
                @if (prj.isSharedByOwner) {
                  <i class="pi pi-cloud" aria-hidden="true"
                    [pTooltip]="'widgets.user-projects.sharedByMe' | translate"></i>
                }
              </div>
            </div>
            <div style="margin-top: -7px;">
              <label class="projectWidgetDetails">{{prj.ownerFullName}}</label>
            </div>
            <div style="font-weight: bold; font-size: 13px;">
              {{ prj.referenceDate | dateMoment:shortDate }}
            </div>
            <div style="margin-top: 5px;">
              <p-progressBar [value]="prj.progress" [showValue]="false"></p-progressBar>
            </div>
          </div>
          <div class="col-sm-1 col-md-1 col-lg-1">
            <p-button styleClass="p-button-help p-button-outlined p-button-raised"
              (click)="selectedProject = prj;activities.toggle($event)" icon="pi pi-calendar"
              [pTooltip]="'widgets.user-projects.projectDetails' | translate"></p-button>
          </div>
        </div>
      </div>
      }
    </div>
    }
    @if (projects && projects.length === 0) {
    <div>
      <div class="row noResultsLabel"> {{ 'app.noData' | translate }}</div>
    </div>
    }
    @if (!projects) {
    <div>
      <div class="m-0 o-0">
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
        <div>
          <div class="flex">
            <div style="flex: 1" class="skeletonClass">
              <p-skeleton width="100%" styleClass="mb-2"></p-skeleton>
              <p-skeleton width="75%"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
    }
  </div>

  <p-overlayPanel #activities appendTo="body">
    <ng-template pTemplate>
      @if (selectedProject) {
      <div>
        @for (activity of selectedProject.activities; track $index) {
        <div class="tableHeader">
          <div class="tableCell">
            <p-tag [severity]="stateConfig[activity.workingState].severity" 
                  [icon]="stateConfig[activity.workingState].icon + ' font-semibold'" 
                  [rounded]="true" 
                  styleClass="p-tag-outlined">
            </p-tag>
          </div>
          <div class="tableCell">
            <a href="javascript:void(0)" pTooltip="{{activity.subject}} - {{activity.ownerFullName}}"
              tooltipPosition="bottom" (click)="onSelectActivity(activity)">
              <label class="truncate activityWidgetLabel"
                style="max-width: 25rem; margin-left: 10px;margin-top: 3px;">{{activity.subject}}</label>
            </a>
          </div>
        </div>
        }
      </div>
      }
    </ng-template>
  </p-overlayPanel>
